import { Component, Input } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { ICallcardTool } from '../../schema/interfaces/ICallcardButtonTool';
import { ButtonsProviderService } from '../../services/buttons-provider/buttons-provider.service';

@Component({
  selector: 'app-callcard-detail-buttons',
  templateUrl: './callcard-detail-buttons.component.html',
  styleUrls: ['./callcard-detail-buttons.component.scss']
})
export class CallcardDetailButtonsComponent {
  @Input()
  card: CallCard;

  get buttonsCount(): number {
    return this.buttonsProvider.buttons.filter(button => button.show).length;
  }

  get callcardToolButtons(): ICallcardTool[] {
    return this.buttonsProvider.buttons;
  }

  constructor(protected buttonsProvider: ButtonsProviderService) {}
}
